import { useEffect, useState } from "react";
import "./Lines.css";

const Lines = ({ selectedJourney }) => {
  const [lines,setLines] = useState([]);

   // Fetch bubble content data
  useEffect(() => {
    fetch("/json/linesData.json")
      .then((res) => res.json())
      .then((data) => setLines(data))
      .catch((err) => console.error("Error loading JSON:", err));
  }, []);

  return (
    <svg
      width="100%"
      height="100%"
      style={{ position: "absolute", left: "0", zIndex: "1" }}
    >
      {/* Render highlighted lines first */}
      {selectedJourney && (selectedJourney?.highlightedLines || []).map((line) => (
        <path
          line={line.id}
          key={line.id}
          d={line.path}
          stroke="#b6dce1"
          fill="transparent"
          strokeWidth="10"
        />
      ))}
      {/* Render all other lines */}
      {(lines || []).map((line) => (
        <path
          key={line.id}
          line={line.id}
          d={line.path}
          stroke="#194F91"
          fill="transparent"
          strokeWidth="1"
        />
      ))}
    </svg>
  );
};

export default Lines;
